module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_Cerave_disabled.2d707a08.png";